import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const SamoaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_16235'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_16235)'>
				<rect
					width='20'
					height='14'
					fill='#E31F37'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M-0.953125 7.46665H10.4754V-0.93335H-0.953125V7.46665Z'
					fill='#083B9A'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.76179 1.86662L4.08836 2.05992L4.2856 1.39996L4.08836 0.73999L4.76179 0.93329L5.43523 0.73999L5.23798 1.39996L5.43523 2.05992L4.76179 1.86662ZM4.76179 6.53329L4.08836 6.72659L4.2856 6.06662L4.08836 5.40666L4.76179 5.59996L5.43523 5.40666L5.23798 6.06662L5.43523 6.72659L4.76179 6.53329ZM2.18359 4.39326L2.85703 4.19996L3.53046 4.39326L3.33322 3.73329L3.53046 3.07332L2.85703 3.26662L2.18359 3.07332L2.38084 3.73329L2.18359 4.39326ZM7.14274 3.73329L6.46931 3.92659L6.66655 3.26662L6.46931 2.60666L7.14274 2.79996L7.81618 2.60666L7.61893 3.26662L7.81618 3.92659L7.14274 3.73329ZM6.19036 4.89996C6.19036 5.02882 6.08376 5.13329 5.95227 5.13329C5.82077 5.13329 5.71417 5.02882 5.71417 4.89996C5.71417 4.77109 5.82077 4.66662 5.95227 4.66662C6.08376 4.66662 6.19036 4.77109 6.19036 4.89996Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default SamoaFlagIcon;
